import { useSelector } from "react-redux";
import { BadgeComponent, ButtonComponent, EmptyModalComponent, ModalComponent, TableComponent } from "../../components";
import { ActionsContainer, EmptyWrapper, ReportJobsWrapper, TableWrapper } from "./report-export-jobs-modal.style";
import moment from "moment";
import { ReportJobsStatusConstant } from "../../pages/report-catalog/report-catalog.constants";
import { LinearProgress } from "@mui/material";

const ReportExportJobsModal = ({ close, label = "Report Jobs", slide }) => {
    const { jobs } = useSelector((state) => state.ReportCatalogReducer);

    const columns = [
        { field: 'id', headerName: 'Job ID', width: 100, align: 'center' },
        { field: 'moduleName', headerName: 'Report Name', width: 150, align: 'center' },
        {
            field: 'status', headerName: 'Status', width: 100, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.status &&
                            <>
                                <BadgeComponent
                                    label={row?.status}
                                    type={{
                                        [ReportJobsStatusConstant?.complete]: 'success',
                                        [ReportJobsStatusConstant?.progress]: 'warning',
                                        [ReportJobsStatusConstant?.failed]: 'error'
                                    }[row?.status] || 'default'}
                                />
                                {
                                    row?.status === ReportJobsStatusConstant?.progress &&
                                    <LinearProgress
                                        sx={{
                                            height: 5,
                                            borderRadius: 5,
                                            marginTop: '6px',
                                            '& .MuiLinearProgress-bar': {
                                                borderRadius: 5,
                                            },
                                        }}
                                    />
                                }
                            </>
                        }
                    </>
                )
            },
            sortBy: (row) => row?.status,
        },
        {
            field: 'submitDateTime', headerName: 'Submitted On', width: 150, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.submitDateTime && (
                                <>
                                    {moment(row?.submitDateTime).format('MMM Do YYYY, h:mm:ss a')}
                                </>
                            )
                        }
                    </>
                )
            },
            sortBy: (row) => row?.submitDateTime,
        },
        {
            field: 'duration', headerName: 'Duration', width: 100, align: 'center',
            valueGetter: (row) => {
                const formatDuration = (ms) => {
                    const d = moment.duration(ms); // ms = milliseconds
                    const h = d.hours();
                    const m = d.minutes();
                    const s = d.seconds();

                    if (h > 0) return `${h}h ${m}m ${s}s`;
                    if (m > 0) return `${m}m ${s}s`;
                    if (s > 0) return `${s}s`;
                    return `${ms}ms`; // show raw ms if < 1s
                };

                return (
                    <>
                        {
                            row?.duration && (
                                <>
                                    {/* {moment.utc(row?.duration * 1000).format('HH:mm:ss')} */}
                                    {/* {moment.duration(row?.duration).humanize()} */}
                                    {formatDuration(row?.duration)}
                                </>
                            )
                        }
                    </>
                )
            },
            sortBy: (row) => row?.duration,
        },
    ];

    return (
        <ModalComponent close={close} label={label} width={900} slide={slide}>
            {
                jobs && jobs.length > 0 ? (
                    <ReportJobsWrapper>
                        <TableWrapper>
                            <TableComponent
                                rows={jobs}
                                columns={columns}
                                // icon={HistorySvg}
                                responsive={false}
                            />
                        </TableWrapper>

                        <ActionsContainer>
                            <ButtonComponent label="Close" type="button" onClick={close} />
                        </ActionsContainer>
                    </ReportJobsWrapper>
                ) : (
                    <EmptyWrapper>
                        <EmptyModalComponent text="No jobs found." />
                    </EmptyWrapper>
                )
            }
        </ModalComponent>
    );
};

export default ReportExportJobsModal;
